export const VIDEO_URLS = {
  howToVote: 'https://player.vimeo.com/video/649207489?h=f49086d1ab&color=68FEE3&autoplay=1'
};
